<script>
import { useAccount } from 'dashboard/composables/useAccount';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default {
  components: {
    TextArea
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['cancel', 'update:show'],
  setup() {
    const { accountId } = useAccount();
    return {
      accountId,
    };
  },
  data() {
    return {
      comment: '',
      selectedAgent: '',
      agentList: [
        { id: 180152197, name: 'CSKH FTECH 01' },
        { id: 182710701, name: 'CSKH FTECH 02' },
      ], 
      customFields: [],
      fieldsState: {}
    };
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    ...mapGetters({ currentChat: 'getSelectedChat' }),
  },
  watch: {
    currentChat() {
      this.resetData()
    },
  },
  mounted() {
    this.getCustomFields()
  },
  methods: {
    getCustomFields() {
      axios.get('https://n8n.dev.ftech.ai/webhook/ticket-custom-field')
        .then(res => {
          if (res.data.code === 'ok') {
            this.customFields = res.data.custom_fields;
          }
        })
        .catch(() => {
          useAlert('Lấy danh sách trường tùy chỉnh thất bại');
        })
    },
    resetData() {
      this.comment = '';
      this.selectedAgent = ''
      this.fieldsState = {}
    },
    onCancel() {
      this.$emit('cancel');
      this.resetData();
    },
    onCreate() {
      const customFields = Object.keys(this.fieldsState).map(item => ({ id: item, value: this.fieldsState[item] }))
      axios.post('https://n8n.dev.ftech.ai/webhook/cs-ticket', {
        comment: this.comment,
        assignedId: this.selectedAgent,
        conversationId: this.currentChat.id,
        customerName: this.currentChat.meta.sender.name,
        customFields
      })
        .then(() => {
          useAlert('Tạo ticket thành công')
        })
        .catch(() => {
          useAlert('Tạo ticket thất bại')
        })
        .finally(() => {
          this.$emit('cancel');
        })
    },
    getShowValue(values) {
      return values?.filter(v => v.parent_value_id === -1 || Object.values(this.fieldsState).includes(v.parent_value_id + '')) || []
    },
    onChangeFieldsState(fieldId, value) {
      const option = this.customFields?.find(field => field.custom_field_id === fieldId)?.values?.find(v => v.id === +value);
      if (option?.parent_value_id  === -1) {
        this.fieldsState = { [fieldId]: value };
        return;
      }
      this.fieldsState[fieldId] = value;
    }
  },
};
</script>

<template>
  <div>
    <woot-modal
      v-model:show="localShow"
      :on-close="onCancel"
    >
      <div class="flex flex-col overflow-auto">
        <h2
          data-test-id="modal-header-title"
          class="text-base font-semibold leading-6 px-6 py-4 text-slate-800 dark:text-slate-50">Tạo ticket</h2>
        <div class="p-3 flex flex-col gap-2">
          <TextArea
            v-model="comment"
            label="Nội dung yêu cầu"
            placeholder="Nhập nội dung yêu cầu" />
          <div>
            <label class="mb-0.5 text-sm font-medium text-n-slate-12">
              Người xử lý
            </label>
            <select v-model="selectedAgent">
              <option
                v-for="agent in agentList"
                :key="agent.id"
                :value="agent.id">
                {{ agent.name }}  
              </option>
            </select>
          </div>
          <template
            v-for="field in customFields"
            :key="field.custom_field_id"
          >
            <template v-if="field.type === 'Text'">
              <woot-input
                :value="fieldsState[field.custom_field_id] || ''"
                class="w-full label-name--input"
                :label="field.custom_field_lable"
                @change="(event) => onChangeFieldsState(field.custom_field_id, event.target.value)"
              />
            </template>
            <template v-else-if="field.type === 'Single drop-down list' && getShowValue(field.values).length">
              <label class="mb-0 text-sm font-medium text-n-slate-12">
                {{ field.custom_field_lable }}
              </label>
              <select
                :value="fieldsState[field.custom_field_id] || ''"
                @change="(event) => onChangeFieldsState(field.custom_field_id, event.target.value)"
              >
                <option
                  v-for="option in getShowValue(field.values)"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.lable }}
                </option>
              </select>
            </template>
            <!-- <template v-else-if="getShowValue(field.values).length">
              <label class="mb-0 text-sm font-medium text-n-slate-12">
                {{ field.custom_field_lable }}
              </label>
              <multiselect
                :value="fieldsState[field.custom_field_id] || ''"
                :options="getShowValue(field.values)"
                track-by="id"
                label="lable"
                multiple
                :close-on-select="false"
                :clear-on-select="false"
                hide-selected
                selected-label
                @change="(event) => onChangeFieldsState(field.custom_field_id, event.target.value)"
              />
            </template> -->
          </template>
          <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
            <button
              class="button clear"
              @click.prevent="onCancel">
              {{ $t('NEW_CONVERSATION.FORM.CANCEL') }}
            </button>
            <woot-button @click.prevent="onCreate">
              Tạo ticket
            </woot-button>
          </div>
        </div>
      </div>
    </woot-modal>
  </div>
</template>